import React from 'react'
import { ChatMessage } from '../chatMessage'

type SetMessages = React.Dispatch<React.SetStateAction<ChatMessage[]>>

type StepMessageHelpers = {
  pushStep: (label: string) => string
  markStepDone: (stepId: string) => void
  markStepError: (stepId: string) => void
}

/**
 * Returns helpers for managing step messages — short status entries that appear
 * inline in the chat while a tool executes. A step is created in 'pending' status
 * and transitions to 'done' or 'error' when the tool completes.
 */
const useStepMessages = (setMessages: SetMessages, nextId: () => string): StepMessageHelpers => {
  const pushStep = (label: string): string => {
    const stepId = nextId()
    setMessages((prev) => [
      ...prev,
      {
        id: stepId,
        sender: 'step',
        text: label,
        timestamp: new Date(),
        stepStatus: 'pending'
      }
    ])
    return stepId
  }

  const markStepDone = (stepId: string): void => {
    setMessages((prev) => prev.map((m) => (m.id === stepId ? { ...m, stepStatus: 'done' } : m)))
  }

  const markStepError = (stepId: string): void => {
    setMessages((prev) => prev.map((m) => (m.id === stepId ? { ...m, stepStatus: 'error' } : m)))
  }

  return { pushStep, markStepDone, markStepError }
}

export default useStepMessages
